module.exports = __webpack_public_path__ + "img/brad.b4238e3.webp";